export default class MarketsConfigModel {
    public main: string[] = null;
    public all: string[] = null;
}